import { RoleIds } from '@efexteam/permission-manager';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import {
  addMemberSchema,
  IAddMemberSchema,
} from '../../schemas/addMember.schema';

const AddMemberFormProvider = ({ children }: { children: React.ReactNode }) => {
  const methods = useForm<IAddMemberSchema>({
    resolver: zodResolver(addMemberSchema),
    mode: 'onChange',
    criteriaMode: 'all',
    defaultValues: {
      email: { label: '', value: 0 },
      userName: '',
      roleId: RoleIds.READ_ONLY,
      authorizationTerms: false,
    },
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};

export default AddMemberFormProvider;
